import {tns} from 'tiny-slider/src/tiny-slider';

export const initTickerSlider = () => {
    for (const slider of document.getElementsByClassName('ticker__slider-container')) {

        const sliderContainer = slider.getElementsByClassName('ticker__slider')[0];

        if (!sliderContainer || sliderContainer.length === 0) {
            return;
        }

        //const autoplay = document.getElementById('auto-scroll-flag') !== null;

        const tinyslider = tns({
            container: sliderContainer,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            items: 1,
            controls: false,
            mouseDrag: false,
            loop: true,
            nav: false,
            disable: false,
            responsive: {
                760: {
                    items: 2,
                    gutter: 20
                },
                1000: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
            //controlsContainer: slider.getElementsByClassName('property-display__slider__controls-container')[0]
        });

        slider.style.height = 'auto';
    }
};
